import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ClassesSection = styled.section`
  width: 100%;
  padding: 72px 0 96px; /* Removed left and right padding */
  max-width: 1304px; /* Match header section width */
  margin: 0 auto;
`;

export const ClassesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 320px);
  gap: 72px 59px;
  justify-content: center;

  @media (width < 1024px) {
    grid-template-columns: repeat(2, minmax(260px, 1fr));
    justify-content: center;
  }

  @media (width < 640px) {
    grid-template-columns: minmax(260px, 1fr);
  }
`;

export const FeaturedCardWrapper = styled.div`
  grid-column: 2 / 4; /* occupy columns 2 and 3 in the second row */
  width: 100%;
  margin: 0;

  @media (width < 1024px) {
    width: 100%;
    max-width: 702px;
    grid-column: 1 / -1;
  }

  /* Override ProductsItem width to fit the grid */
  & > div {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Override Container height to match ClassImage with aspect-ratio: 1 (320px × 1 = 320px) */
  & > div > div {
    @media (max-width: 1023px) {
      height: 260px !important;
      min-height: 260px !important;
    }

    @media (min-width: 1024px) {
      height: 320px !important;
      min-height: 320px !important;
    }
  }

  /* Make image container and image fill the full height */
  & > div > div > a {
    height: 100% !important;
  }

  & > div > div > a img {
    width: 100% !important;
    height: 100% !important;
    /* Match main rewards grid image behavior (show full image, no hard crop). */
    object-fit: contain !important;
    object-position: center;
  }

  /* Override ProductName styling for featured card - target with high specificity */
  & div[class*="ProductName"],
  & a[href*="/rewards/"]:not(:first-child),
  & > div > div > a:nth-of-type(2),
  & > div > div > div > a[href*="/rewards/"] {
    font-family: "Yellix", system-ui, sans-serif !important;
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 18px !important;
    line-height: 22px !important;
    letter-spacing: 0.01em !important; /* 1% */
  }
`;


export const ClassCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-4px);
  }
  
  @media (max-width: 1023px) {
    min-height: 367px;
  }
  
  @media (min-width: 1024px) {
    width: 320px;
    height: 551px;
  }
`;

export const ClassImage = styled.div`
  width: 100%;
  aspect-ratio: 1;
  background-color: transparent;
  background-position: center;
  /* Show the full image inside the fixed square tile (no hard crop). */
  background-size: contain;
  background-repeat: no-repeat;
  ${(props) =>
    props.$imageSrc &&
    `
    background-image: url(${props.$imageSrc});
  `}
`;

export const ClassContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  line-height: 1.4;
`;

export const Brand = styled.span`
  display: inline-block;
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700; /* Bold */
  font-style: normal;
  font-size: 12px;
  line-height: 25px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #E1000F;
`;

export const ClassName = styled.h3`
  margin-top: 4px;
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em; /* 1% */
`;

export const Meta = styled.p`
  margin: 0;
  color: #555;
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700; /* Bold for datetime */
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.01em; /* 1% */
`;

export const Location = styled.p`
  margin: 0;
  color: #555;
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 500; /* Medium for location */
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.01em; /* 1% */
`;

export const Points = styled.p`
  margin: 8px 0 0;
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700; /* Bold */
  font-style: normal;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0;
`;
